<template>
  <div class="landing-page">
    <div class="divider"></div>
    <skills-modal ref='skills'/>
    <div class="container dark-text">
      <container title="About Me">
        <div class="is-size-5 container2 desktop">
          <topic class="topic" v-for="topic in topics" :key="topic.icon" :icon='topic.icon' :text='topic.text' :action='topic.action'/>
        </div>
        </container>
      <container class="interests" title="Interests"> 
        <div class="is-size-5 container2 desktop">
          <topic v-for="topic in interests" :key="topic.icon" :icon='topic.icon' :text='topic.text' :action='topic.action'/>
        </div>
      </container>
    </div>
  </div>
</template>

<script>

import container from "@/components/structure/Section.vue"
import topic from "@/components/structure/Topic.vue"
import SkillsModal from '@/components/structure/SkillsModal.vue'

export default {
  name: 'About',
  components: {
    container,
    topic,
    SkillsModal
  },
  data: function(){
    return {
      topics: [
        {icon: 'europe.svg', text: 'Portugal', action: null},
        {icon: 'gamedevlove.svg', text: 'Game Dev at Heart', action: null},
        {icon: 'skills.svg', text: 'Skills', action: this.showSkills},
      ],
      interests: [
        {icon: 'rendering.svg', text: 'Realtime Rendering', action: null},
        {icon: 'ai.svg', text: 'Artificial Intelligence', action: null},
        {icon: 'design.svg', text: 'Digital Design', action: null},
      ]
    }
  },
  methods: {
    showSkills(){
      this.$refs['skills'].open();
    }
  }
    
}
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.landing-page{
  margin: 0px;
  width: 100%;
  overflow: hidden;
  position: relative;
  background: var(--bright-color);
}

@media screen and (min-width:601px){
  .desktop{
    flex-direction: column;
  }
}

@media screen and (max-width:601px){
  .desktop{
    flex-direction: column !important;
    justify-content: center;
    align-items: center;
  }
}

.topic{
  margin: 1em;
  margin-top: 0;
  font-size: 1.3em;
  width: 130px;
}

.container div:last-child{
  padding-bottom: 0.5em;
}

.container2{
  justify-content: center;
  display: flex;
  flex-direction: row;
}

.col{
  height: 50%;
  display: flex;
}
.vertical{
  flex-direction: column;
}
.text{
  width:100%;
}

.align-bottom{
  align-items: flex-end;
  display: flex;
}

.align-top{
  align-items: flex-start;
  display: flex;
}


@media screen and (min-width:601px){
  .name{
    font-size: 5em;
  }
  .profession{
    font-size: 3em;
  }
  .quote{
    font-size: 1.5em;
  }
}

@media screen and (max-width:600px){
  .name{
    font-size: 4em;
  }
  .profession{
    font-size: 2.4em;
  }
  .quote{
    font-size: 1.5em;
  }
}



</style>
